import React from 'react';
import { Button } from 'react-bootstrap';
import FilterAccordion from './components/filtersAccordion';
import FiltersAccordionTreeView from './components/filtersAccordionTreeView';
import PropTypes from 'prop-types';
import ActivityTypes from '../../../../../../enums/activityTypes';

const SearchFilter = ({ 
  filtersToShow,
  filterChange,
  setFilterChange,
  setCurrentSearchData,
  filterSearchCall,
  mapSearchResults,
  setSelectedPage,
  dataPerPage,
  dataFound,
  keywords,
  context,
  activityType
}) => {
  const handleResetFilters = () => {
    var searchRequest = {
      keyword: null,
      pageNumber: 1,
      pageSize: 25,
      courseIds: [],
      levels: []
    };
    setFilterChange(!filterChange);
    setCurrentSearchData({ ...searchRequest, searchType: 'filter' });
    filterSearchCall(searchRequest).then((results) => { mapSearchResults(results, true); setSelectedPage(1); });
  };

  
  const buildSearchRequest = (clearFilter) => {
    const isCleared = (filterName) => clearFilter === filterName;
    const getFilterValues = (filters, checked = true, mapKey = 'id') => 
      filters && filters.filter(f => checked ? f.isChecked : !f.childIds && f.isChecked).map(f => f[mapKey]);
    const getQuestionTypeChecked = (checkboxId) => 
      !context.questionTypeFilters ? false : isCleared('Question Types (MC/FI/CR)') ? false : context.questionTypeFilters.filter((f) => f.id === checkboxId && f.isChecked).length === 1;
    const hasContextProperty = (prop) => context && context[prop] !== undefined;

    const searchRequest = {
      keyword: keywords,
      pageNumber: 1,
      pageSize: dataPerPage
    };

    if (hasContextProperty('contentAreaFilters')) {
      searchRequest.courseIds = isCleared('Content Area') ? [] : context.contentAreaFilters.filter(f => f.isChecked).map(f => f.id);
    }
    if (hasContextProperty('levelFilters')) {
      searchRequest.levels = isCleared('Levels') ? [] : getFilterValues(context.levelFilters);
    }
    if (hasContextProperty('questionTypeFilters')) {
      searchRequest.multipleChoice = getQuestionTypeChecked('mcCheckbox');
      searchRequest.constructedResponse = getQuestionTypeChecked('crCheckbox');
      searchRequest.fillIn = getQuestionTypeChecked('fiCheckbox');
    }
    if (hasContextProperty('translationFilters')) {
      searchRequest.spanishOnly = isCleared('Translations Available') ? false : context.translationFilters.filter(f => f.id === 'spQuestionsCheckbox' && f.isChecked).length === 1;
    }
    if (hasContextProperty('questionSourceFilters')) {
      searchRequest.includeTeacherContent = isCleared('questionSource') ? false : context.questionSourceFilters.filter(f => f.id === 'tQuestionsCheckbox' && f.isChecked).length === 1;
      searchRequest.includeCastleQuestions = isCleared('questionSource') ? false : context.questionSourceFilters.filter(f => f.id === 'cQuestionsCheckbox' && f.isChecked).length === 1;
    }
    if (hasContextProperty('standardFilters')) {
      searchRequest.standards = isCleared('Standards') ? [] : getFilterValues(context.standardFilters, false, 'nodename');
    }
    if (hasContextProperty('personalAssignmentFilters')) {
      searchRequest.teacherAssignmentIds = isCleared(`Personal ${activityType == ActivityTypes.Assignment ? 'Assignments' : 'Flashcards'}`) ? [] : getFilterValues(context.personalAssignmentFilters);
    }
    if (hasContextProperty('publicAssignmentFilters')) {
      searchRequest.publicAssignmentIds = isCleared(`Public ${activityType == ActivityTypes.Assignment ? 'Exams & Assignments' : 'Flashcards'}`) ? [] : getFilterValues(context.publicAssignmentFilters);
    }
    if (hasContextProperty('topicFilters')) {
      searchRequest.topics = isCleared('Topics') ? [] : getFilterValues(context.topicFilters, false);
    }
    if (hasContextProperty('tagFilters')) {
      searchRequest.tags = isCleared('Tags') ? [] : getFilterValues(context.tagFilters);
    }
    if (hasContextProperty('attributeFilters')) {
      searchRequest.attributes = isCleared('Attributes') ? [] : getFilterValues(context.attributeFilters);
    }
    if (hasContextProperty('teacherContentSetsFilter')) {
      searchRequest.teacherContentSetIds = isCleared('My Content Sets') ? [] : getFilterValues(context.teacherContentSetsFilter);
    }

    return searchRequest;
  };

  const handleApplyFilters = (clearFilter) => {
    const searchRequest = buildSearchRequest(clearFilter);
    setFilterChange(!filterChange);
    setCurrentSearchData({ ...searchRequest, searchType: 'filter' });
    filterSearchCall(searchRequest).then((results) => { mapSearchResults(results); setSelectedPage(1); });
  };

  const filterConfig = [
    { key: 'standards', title: 'Standards', component: 'TreeView', filters: 'standardFilters', setFilters: 'setStandardFilters', filtersApplied: 'standardFiltersApplied', showClassicCourseSlider: false },
    { key: 'questionTypes', title: 'Question Types (MC/FI/CR)', component: 'Accordion', filters: 'questionTypeFilters', setFilters: 'setQuestionTypeFilters' },
    { key: 'contentArea', title: 'Content Area', component: 'Accordion', filters: 'contentAreaFilters', setFilters: 'setContentAreaFilters' },
    { key: 'levels', title: 'Levels', component: 'Accordion', filters: 'levelFilters', setFilters: 'setLevelFilters' },
    { key: 'topics', title: 'Topics', component: 'TreeView', filters: 'topicFilters', setFilters: 'setTopicFilters', filtersApplied: 'topicFiltersApplied', showClassicCourseSlider: true },
    { key: 'translations', title: 'Translations Available', component: 'Accordion', filters: 'translationFilters', setFilters: 'setTranslationFilters' },
    { key: 'personalAssignments', title: `Personal ${activityType == ActivityTypes.Assignment ? 'Assignments' : 'Flashcards'}`, component: 'Accordion', filters: 'personalAssignmentFilters', setFilters: 'setPersonalAssignmentFilters' },
    { key: 'teacherContentSets', title: 'My Content Sets', component: 'Accordion', filters: 'teacherContentSetsFilter', setFilters: 'setTeacherContentSetsFilter' },
    { key: 'publicAssignments', title: `Public ${activityType == ActivityTypes.Assignment ? 'Exams & Assignments' : 'Flashcards'}`, component: 'Accordion', filters: 'publicAssignmentFilters', setFilters: 'setPublicAssignmentFilters' },
    { key: 'tags', title: 'Tags', component: 'Accordion', filters: 'tagFilters', setFilters: 'setTagFilters' },
    { key: 'attributes', title: 'Attributes', component: 'Accordion', filters: 'attributeFilters', setFilters: 'setAttributeFilters' }
  ];

  const renderFilterComponent = (config) => {
    if (!filtersToShow.includes(config.key)) return null;

    const commonProps = {
      title: config.title,
      filterOptions: context[config.filters],
      setFilterOptions: context[config.setFilters],
      handleApplyFilters
    };

    if (config.component === 'TreeView') {
      return (
        <FiltersAccordionTreeView
          key={config.key}
          {...commonProps}
          context={context}
          filtersApplied={context[config.filtersApplied]}
          showClassicCourseSlider={config.showClassicCourseSlider}
        />
      );
    }

    return <FilterAccordion key={config.key} {...commonProps} />;
  };

  const buttonGroup = (
    <div className='d-flex flex-row justify-content-between mb-3 mt-1 gap-3'>
      <Button variant='castleGray' className='w-100' onClick={() => handleResetFilters()} disabled={!dataFound}>Clear All</Button>
      <Button variant='castleWhite' className='w-100' onClick={() => handleApplyFilters()} disabled={!dataFound}>Apply</Button>
    </div>
  );

  return (
    <div className='d-flex flex-column whiteCard filter-search-container'>
      <h1>Filter Search</h1>
      {buttonGroup}
      {filterConfig.map(renderFilterComponent)}
      {buttonGroup}
    </div>
  );
};

SearchFilter.propTypes = {
  filters: PropTypes.object,
  filtersToShow: PropTypes.object,
  setCurrentSearchData: PropTypes.func,
  mapSearchResults: PropTypes.func,
  setSelectedPage: PropTypes.func,
  dataPerPage: PropTypes.number,
  keywords: PropTypes.string,
  filterSearchCall: PropTypes.func,
  dataFound: PropTypes.bool,
  filterChange: PropTypes.bool,
  setFilterChange: PropTypes.func,
  context: PropTypes.object,
  activityType: PropTypes.number
};

export default SearchFilter;
